import React, { useState, useEffect } from "react";
import Typing from "react-typing-animation";
import { GitHub, Public } from "@material-ui/icons";
import { PropagateLoader } from "react-spinners";

import Particle from "../../Components/Particle";
import projectData from "../../Components/projectsData";
import "./Work.css";
import "../../loadingStyle.css";

const ProjectCard = ({ title, date, description, link, icon, position }) => {
  const containerClass = `container ${position}`;

  return (
    <div className={containerClass}>
      <div className="content">
        <h2>{title}</h2>
        <h4>{date}</h4>
        <p>{description}</p>
        <a href={link} target="_blank" rel="noreferrer">
          {icon === "Public" ? (
            <Public style={{ color: "#24292E" }} />
          ) : (
            <GitHub style={{ color: "#24292E" }} />
          )}
        </a>
      </div>
    </div>
  );
};

const Work = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    setTimeout(() => {
      if (isMounted) {
        setLoading(false);
      }
    }, 850);
  
    return () => {isMounted = false};
  }, []);
  

  return (
    <div>
      {loading ? (
        <div className="loading">
          <PropagateLoader color="#F9880D" loading={loading} size={15} />
        </div>
      ) : (
        <div>
          <Particle />
          <div className="work__content">
            <div className="work__content__heading">
              <Typing
                cursorClassName="custom"
                cursor={<span>_</span>}
                speed={80}
              >
                <h1>My Work</h1>
              </Typing>
            </div>

            <div className="work__content__content">
              <div className="timeline">
                {projectData.map((project, index) => (
                  <ProjectCard key={index} {...project} />
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Work;
